import { useEffect, useState } from "react";

export const useGeolocation = () => {
    const [coords, setCoords] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const capture = () => {
        if (!("geolocation" in navigator)) {
            setError("Geolocalización no disponible");
            return;
        }
        setLoading(true);
        setError(null);

        navigator.geolocation.getCurrentPosition(
            (pos) => {
                const { latitude, longitude, accuracy } = pos.coords;
                
                // Validar que las coordenadas sean válidas
                if (isValidCoordinates(latitude, longitude)) {
                    setCoords({ 
                        lat: latitude, 
                        lon: longitude, 
                        accuracy: Math.round(accuracy) 
                    });
                    setError(null);
                } else {
                    setError("Coordenadas GPS inválidas");
                    setCoords(null);
                }
                setLoading(false);
            },
            (err) => {
                console.error('Error de geolocalización:', err);
                let errorMessage = "No fue posible obtener la ubicación";
                
                switch(err.code) {
                    case err.PERMISSION_DENIED:
                        errorMessage = "Permisos de ubicación denegados";
                        break;
                    case err.POSITION_UNAVAILABLE:
                        errorMessage = "Ubicación no disponible";
                        break;
                    case err.TIMEOUT:
                        errorMessage = "Tiempo de espera agotado para GPS";
                        break;
                    default:
                        errorMessage = err.message || "Error de ubicación";
                }
                
                setError(errorMessage);
                setCoords(null);
                setLoading(false);
            },
            { 
                enableHighAccuracy: true, 
                timeout: 5000, 
                maximumAge: 0
            }
        );
    };

    // Función para validar coordenadas
    const isValidCoordinates = (lat, lon) => {
        return !isNaN(lat) && !isNaN(lon) && 
               lat >= -90 && lat <= 90 && 
               lon >= -180 && lon <= 180 &&
               lat !== 0 && lon !== 0; // Evitar coordenadas 0,0
    };

    // Verificar si las coordenadas son válidas y recientes
    const isLocationValid = () => {
        return coords && 
               isValidCoordinates(coords.lat, coords.lon) && 
               !loading && 
               !error;
    };

    useEffect(() => {
        capture();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { 
        coords, 
        error, 
        loading, 
        recapture: capture,
        isLocationValid: isLocationValid()
    };
}
